var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: _vm.pram.id ? "编辑卡片信息" : "新增卡片信息",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "120px", model: _vm.pram } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "卡片名称：",
                    prop: "cardName",
                    rules: [
                      {
                        required: true,
                        message: "请填写卡片名称",
                        trigger: ["change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写卡片名称" },
                    model: {
                      value: _vm.pram.cardName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "cardName", $$v)
                      },
                      expression: "pram.cardName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "简称：", prop: "shortName" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写简称" },
                    model: {
                      value: _vm.pram.shortName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "shortName", $$v)
                      },
                      expression: "pram.shortName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "福卡用途：", prop: "cardPurpose" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择福卡用途" },
                      model: {
                        value: _vm.pram.cardPurpose,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "cardPurpose", $$v)
                        },
                        expression: "pram.cardPurpose",
                      },
                    },
                    _vm._l(_vm.cardPurposeOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "卡片状态：",
                    prop: "status",
                    rules: [
                      {
                        required: true,
                        message: "请选择卡片状态",
                        trigger: ["change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.pram.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "status", $$v)
                        },
                        expression: "pram.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("启用"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("禁用"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "所属小程序：", prop: "appName" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        placeholder: "请选择所属小程序",
                        filterable: "",
                      },
                      on: { change: _vm.handleAppChange },
                      model: {
                        value: _vm.pram.appName,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "appName", $$v)
                        },
                        expression: "pram.appName",
                      },
                    },
                    _vm._l(_vm.miniProgramList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.appName, value: item.appName },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否套餐卡：", prop: "isCombo" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.pram.isCombo,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "isCombo", $$v)
                        },
                        expression: "pram.isCombo",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("是"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("否"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "频道权限：", prop: "channelIds" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        clearable: "",
                        placeholder: "请选择",
                        filterable: "",
                        "filter-method": _vm.handleAgreementSearch,
                      },
                      on: { change: _vm.changeBrand },
                      model: {
                        value: _vm.pram.channelIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "channelIds", $$v)
                        },
                        expression: "pram.channelIds",
                      },
                    },
                    _vm._l(_vm.brandOption, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.channel_name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "卡片优先级：", prop: "priority" } },
                [
                  _c("el-input-number", {
                    attrs: { clearable: "", placeholder: "请填写" },
                    model: {
                      value: _vm.pram.priority,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "priority", $$v)
                      },
                      expression: "pram.priority",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "卡片样式：",
                    prop: "styleImg",
                    rules: _vm.pram.isCombo
                      ? []
                      : [
                          {
                            required: true,
                            message: "请上传卡片样式",
                            trigger: ["change"],
                          },
                        ],
                  },
                },
                [
                  _vm.userType === 1
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "upLoadPicBox",
                              on: {
                                click: function ($event) {
                                  return _vm.modalPicTap("1", "styleImg")
                                },
                              },
                            },
                            [
                              _vm.pram.styleImg
                                ? _c("div", { staticClass: "pictrue" }, [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.pram.styleImg,
                                        alt: "",
                                      },
                                    }),
                                  ])
                                : _c("div", { staticClass: "upLoad" }, [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-camera cameraIconfont",
                                    }),
                                  ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.pram.styleImg
                            ? _c("i", {
                                staticClass: "el-icon-delete",
                                staticStyle: {
                                  color: "red",
                                  "font-size": "16px",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeImg("styleImg")
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                action: "",
                                "show-file-list": false,
                                "http-request": function (options) {
                                  return _vm.handleLocalUpload(
                                    options,
                                    "styleImg"
                                  )
                                },
                                "before-upload": _vm.beforeUpload,
                                accept: "image/*",
                              },
                            },
                            [
                              _vm.pram.styleImg
                                ? _c("img", {
                                    staticClass: "avatar",
                                    attrs: { src: _vm.pram.styleImg },
                                  })
                                : _c("i", {
                                    staticClass:
                                      "el-icon-plus avatar-uploader-icon",
                                  }),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.pram.styleImg
                            ? _c("i", {
                                staticClass: "el-icon-delete",
                                staticStyle: {
                                  color: "red",
                                  "font-size": "20px",
                                  "margin-left": "10px",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeImg("styleImg")
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "主题色：", prop: "color" } },
                [
                  _c("el-color-picker", {
                    attrs: { "show-alpha": "" },
                    model: {
                      value: _vm.pram.color,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "color", $$v)
                      },
                      expression: "pram.color",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "边框色：", prop: "borderColor" } },
                [
                  _c("el-color-picker", {
                    attrs: { "show-alpha": "" },
                    model: {
                      value: _vm.pram.borderColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "borderColor", $$v)
                      },
                      expression: "pram.borderColor",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "背景色：", prop: "backgroundColor" } },
                [
                  _c("el-color-picker", {
                    attrs: { "show-alpha": "" },
                    model: {
                      value: _vm.pram.backgroundColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "backgroundColor", $$v)
                      },
                      expression: "pram.backgroundColor",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "面值文字颜色：", prop: "textColor" } },
                [
                  _c("el-color-picker", {
                    attrs: { "show-alpha": "" },
                    model: {
                      value: _vm.pram.textColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "textColor", $$v)
                      },
                      expression: "pram.textColor",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "使用说明：", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "使用说明",
                    },
                    model: {
                      value: _vm.pram.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "remark", $$v)
                      },
                      expression: "pram.remark",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "内部备注：", prop: "innerRemark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "内部备注（仅后台可见）",
                    },
                    model: {
                      value: _vm.pram.innerRemark,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "innerRemark", $$v)
                      },
                      expression: "pram.innerRemark",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "核销供应商：", prop: "supplierIdList" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.pram.supplierIdList,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "supplierIdList", $$v)
                        },
                        expression: "pram.supplierIdList",
                      },
                    },
                    _vm._l(_vm.autoList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.supplierName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "核销跳转地址：",
                    prop: "offlineJumpId",
                    rules: [
                      {
                        validator: _vm.validateOfflineJumpId,
                        trigger: ["change", "blur"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "number",
                      clearable: "",
                      placeholder: "请填写核销跳转地址ID",
                    },
                    model: {
                      value: _vm.pram.offlineJumpId,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "offlineJumpId", $$v)
                      },
                      expression: "pram.offlineJumpId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "跳转核销商家：", prop: "turnMerchant" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.pram.turnMerchant,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "turnMerchant", $$v)
                        },
                        expression: "pram.turnMerchant",
                      },
                    },
                    _vm._l(_vm.selectedSupplierList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.supplierName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.handerSubmit("pram")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }